module.exports = __webpack_public_path__ + "static/media/preview-thumbnail-12.9916026e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pseudodocs/preview-thumbnail-12.jpg
// module id = 1898
// module chunks = 2